<template lang="pug">
  el-form(
    :model="form"
    v-loading="loadingForm"
    ref="AddUserForm"
    :rules="addUserFormRules"
    @submit.native.prevent
  )
    el-row.justify-center
      el-col(:span="24")
        .snooze-form
          .snooze-message.text-center
            | Snooze upcoming 
            strong {{ notification.info_type }}
            |  notifications for 
            strong {{ notification.sensor_transmitter.name }}
            |  ( 
            strong {{ notification.soil_sensor.name }}
            | ) from 
            strong {{ notification.sensor_transmitter.field_name }}
          
          SingleDateTimePicker.snooze-date(
            style="margin: auto;"
            v-model="form.ends_at"
            type="datetime"
            format="dd/MM/yyyy HH:mm"
            :value-format="'yyyy-MM-dd HH:mm:ss'"
            :reset-signal="resetKey"
            @onChange="handleEndsAtChange"
            @invalid="showDateError"
          )

    el-row.text-center
      el-button.dark-green-btn.pop-up-btn(
        @click="handleSendForm('AddUserForm')"
        :loading="loading"
      ) {{ $t('common.confirm') }}
</template>

<script>
import FilterDatePicker from "@components/_shared/FilterDatePicker";
import SingleDateTimePicker from "@components/_shared/SingleDateTimePicker";
import { mapActions, mapMutations, mapState } from "vuex";
import { customValidations } from "@utils/customValidators";
import { usersViewValidations } from "@utils/formValidations/usersViewValidations";
import { setObjectValues } from "@utils/generalUtils";
import _ from "lodash";

export default {
  name: "AddSnoozeNotification",
  mixins: [usersViewValidations, customValidations],

  components: {
    FilterDatePicker,
    SingleDateTimePicker
  },

  data() {
    return {
      selectedPlaceID: null,
      foundPlacesByPin: [],
      form: {
        soil_sensor_id: null,
        info_type: null,
        ends_at: null
      },
      sites: [],
      roles: [],
      dateRange: [],

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 60000; // disables dates/times before current minute
        }
      },

      loading: false,
      loadingForm: false,
      setObjectValues,
    };
  },

  computed: {
    ...mapState("auth", ["user"]),

    ...mapState("map", ["changedDialog"]),
    ...mapState("notification", ["notification"]),


  },

  created() {
    this.loadingForm = true;
    this.handleGetFormData();
    this.loadingForm = false;
  },

  async mounted() {

  },

  methods: {
    ...mapActions("snoozeNotification", ["addSnoozeNotification"]),
    ...mapActions("site", ["getSites"]),
    ...mapActions("role", ["getRoles"]),

    ...mapMutations("dialog", ["hideAddSnoozeNotificationDialog"]),

    ...mapMutations("notification", ["setShouldFetchNotifications"]),

    async handleChange(values) {
      this.transmitterInfos = [];
      this.loadingStatistics = true;

      let computedParams = `?by_sensor_transmitter_id=${this.transmitter.id}`;
      if (values && values.length > 0) {
        let dateRangeComputed = {
          start_date: values[0],
          end_date: values[1],
        };

        computedParams += `&by_date_range[start_date]=${dateRangeComputed.start_date}&by_date_range[end_date]=${dateRangeComputed.end_date}`;
        this.dateRange = [dateRangeComputed.start_date, dateRangeComputed.end_date];
        
        const response = await this.getSensorTransmitterInfo(computedParams);
        this.transmitterInfos = response;
      } 
      else {
        this.transmitterInfos = [];
      }
    this.loadingStatistics = false;

    },

    handleGetFormData() {
      if (!this.notification) return false;
      // this.form = { ...this.customer }; 
      this.form.soil_sensor_id = this.notification.soil_sensor_id;
      this.form.info_type = this.notification.info_type;
    },

    clearForm() {
      this.setObjectValues(this.form, "");
    },

    async handleSendForm(formName) {
      this.loading = true;
      const form = this.$refs[formName];

      // Check if ends_at is present
      if (!this.form.ends_at) {
        this.$message.error("Please select a date and time.");
        this.loading = false;
        return;
      }

      if (!this.form.ends_at || new Date(this.form.ends_at).getTime() <= Date.now()) {
        this.$message.error("Please select a future date and time.");
        this.loading = false;
        return;
      }

      const payload = {
        info_type: this.form.info_type,
        soil_sensor_id: this.form.soil_sensor_id,
        ends_at: this.formatDateUTC(this.form.ends_at)
      };

      try {
        await this.addSnoozeNotification(payload);
        this.hideAddSnoozeNotificationDialog();
        this.clearForm();
        this.setShouldFetchNotifications(true);
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }

    },

    formatDateUTC(date) {
      const pad = (n) => (n < 10 ? '0' + n : n);
      return (
        date.getUTCFullYear() +
        '-' +
        pad(date.getUTCMonth() + 1) +
        '-' +
        pad(date.getUTCDate()) +
        ' ' +
        pad(date.getUTCHours()) +
        ':' +
        pad(date.getUTCMinutes()) +
        ':' +
        pad(date.getUTCSeconds())
      );
    }

  },
};
</script>

<style lang="scss" scoped>
.snooze-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;

  .snooze-message {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    line-height: 1.4;
    margin-bottom: 10px;
  }

}

.pop-up-btn {
  width: 140px;
  height: 40px;
  font-weight: bold;
  border-radius: 20px;
}
</style>